import React, { useEffect } from "react";
import Link from "next/link";
import RatingProgressBar from "./rating-progress-bar";
import ReviewCard from "./review-card";
import DoubleHeading from "./double-heading";
import { content } from "../../utils/content/product";

const Reviews = ({ product = {}, reviews, lang }) => {
  if (!product.numOfReviews) return <></>;

  return (
    <div className="mt-10">
      <DoubleHeading text={content["reviewHeading"][lang]} />
      <div className="flex p-3 sm:px-24 pt-10 flex-col-reverse md:flex-row flex-1 bg-white">
        {product.numOfReviews !== 0 ? null : (
          <p className="text-center">
            The product has no reviews . Be the first one to review
          </p>
        )}
        <div className="flex-1">
          {reviews
            ? reviews.data.map((review, index) => (
                <ReviewCard lang={lang} key={index} review={review} />
              ))
            : null}
        </div>

        <div className="flex-1 bg-white sm:mb-0 mb-14">
          {reviews && product.numOfReviews !== 0 ? (
            <RatingProgressBar product={product} reviews={reviews} />
          ) : null}
        </div>
      </div>

      {product.numOfReviews > 2 ? (
        <Link href={"/ratings?id=" + product.id}>
          <div className="pt-4 mb-14">
            <p className="text-center text-2xl pb-6 heading-primary-blue font-medium hover:cursor-pointer ">
              <button className="inline-flex justify-center  py-2 px-4 border border-transparent shadow-sm text-mds font-medium rounded-md text-white bg-tn-blue  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                {content["seeReviews"][lang]}
              </button>
            </p>
          </div>
        </Link>
      ) : null}
    </div>
  );
};

export default Reviews;
